import React from 'react';

import {ProfileTabSeparator} from 'src/components/profile-tab-structure';
import {STATSIG_GATES} from 'src/contexts/statsig-contex';
import {ACCESS_RIGHTS, useAdminAccessRight} from 'src/hooks/access-rights';
import {AccountManagersSection} from 'src/modules/profile/account/tabs/account-profile/account-managers-section';
import {LicenseSection} from 'src/modules/profile/account/tabs/account-profile/license-section';
import {AccountNotesSection} from 'src/modules/profile/account/tabs/account-profile/notes-section';
import {ProductAccessSummarySection} from 'src/modules/profile/account/tabs/account-profile/product-access-summary-section';
import {UsersSection} from 'src/modules/profile/account/tabs/account-profile/users-section';

import {StickyElement} from '@pb/kit-component-sticky-element';
import {useGateValue} from '@pb/kit-lib-statsig';

import {AccountPageTabs} from './account-page-tabs';

import {
    accountPageStructure,
    accountPageStructureMain,
    accountPageStructureSidebar,
    accountPageStructureWrapper,
} from './account-page-structure.module.styl';


type Props = {
    accountId: number,
    activeTab: string,
    children: React.ReactNode,
    showSidebar?: boolean,
};

export const AccountPageStructure = ({accountId, children, showSidebar, activeTab}: Props) => {
    const {hasAccess, canViewAccountProducts} = useAdminAccessRight();
    const canViewLicense = hasAccess(ACCESS_RIGHTS.LICENSE_SCREEN_VIEW);
    const isPumaAvailable = useGateValue(STATSIG_GATES.PUMA);

    return (
        <div className={`enable-selection ${accountPageStructureWrapper}`}>
            <StickyElement findStickToElement={true}>
                <AccountPageTabs {...{accountId, activeTab}}/>
            </StickyElement>
            <div className={accountPageStructure}>
                {showSidebar ? (
                    <div className={accountPageStructureSidebar}>
                        {canViewLicense ? (
                            <>
                                <LicenseSection key="account-license-section" accountId={accountId}/>
                                <ProfileTabSeparator/>
                            </>
                        ) : null}
                        <UsersSection accountId={accountId}/>
                        {isPumaAvailable && canViewAccountProducts(accountId) ? (
                            <>
                                <ProfileTabSeparator/>
                                <ProductAccessSummarySection accountId={accountId}/>
                            </>
                        ) : null}
                        <ProfileTabSeparator/>
                        <AccountManagersSection accountId={accountId}/>
                        <ProfileTabSeparator/>
                        <AccountNotesSection accountId={accountId}/>
                    </div>
                ) : null}
                <div className={accountPageStructureMain}>{children}</div>
            </div>
        </div>
    );
};
